import { getShopUrl, getShopPrimaryUrl } from './helpers';

class LoyaltyService {
  constructor() {
    this.api = {
      getRewardsBalance: this.getRewardsBalance.bind(this)
    };
  }

  async getRewardsBalance({ id, onSuccess, onError }) {
    try {
      const shopUrl = getShopPrimaryUrl() || getShopUrl();
      const response = await
        fetch(`https://${shopUrl}/apps/bbloyalty/loyalty/${id}`);
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      const data = await response.json();
      
      if (data.success && data.data) {
        // Map to Cardigan format with hard-coded CAD currency
        const result = {
          reward: {
            currency: 'CAD',
            balance: data.data.reward_balance
          }
        };
        
        onSuccess(result);
      } else {
        throw new Error(data.message || 'Invalid response format');
      }
    } catch (error) {
      onError({ error: error.message });
    }
  }
}

// Create global instance to match Cardigan pattern
window.LoyaltyService = new LoyaltyService();

export default LoyaltyService;
